import { NetworkSelector, WrongNetworkMessage } from '@/components/molecules'
import { ConnectWallet, Footer } from '@/components/organisms'
import { navItems } from '@/constants'
import { useWeb3 } from '@/hooks'
import { Button, HStack, useBreakpointValue } from '@chakra-ui/react'
import { FreshMainLogo, LayoutTemplate, Navbar } from '@erinaceus/ui'
import { APPS, getMonorepoAppUrl } from '@erinaceus/utils'
import { Link, useNavigate } from 'react-router-dom'
import { useAccount } from 'wagmi'
import { MainContainer } from '../atoms'
import { ArrowBackIcon } from '@chakra-ui/icons'

export const Layout = ({
  detectNetwork = true,
  withBackButton = false,
  children,
  ...rest
}) => {
  const { isCorrectChain } = useWeb3()
  const { isConnected } = useAccount()

  const navigate = useNavigate()
  const isSmallScreen = useBreakpointValue({ base: true, sm: false })
  const isNetworkCorrect = isConnected && detectNetwork && isCorrectChain
  const showChildren = isNetworkCorrect || !detectNetwork || !isConnected

  const website = getMonorepoAppUrl({ app: APPS.WEBSITE })
  return (
    <LayoutTemplate {...rest}>
      <Navbar
        logo={
          <FreshMainLogo
            onClick={() => {
              window.location.href = website
            }}
          />
        }
        navItems={navItems}
        LinkElement={Link}
      >
        <HStack>
          <NetworkSelector />
          <ConnectWallet
            // size={'sm'}
            // color={'primary.100'}
            symbols={isSmallScreen ? 2 : 6}
            // alignSelf={'flex-end'}
            // _hover={{
            //   color: 'primary.200',
            // }}
          />
        </HStack>
      </Navbar>

      {withBackButton && (
        <MainContainer p={0}>
          <Button
            minHeight={'40px'}
            variant={'outline'}
            leftIcon={<ArrowBackIcon />}
            alignSelf={'flex-start'}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </MainContainer>
      )}

      {showChildren ? children : <WrongNetworkMessage />}

      <Footer />
    </LayoutTemplate>
  )
}
